import React, { useState } from 'react'
import { Formik, Form, Field, ErrorMessage } from "formik";

export default function InquiryForm({ openInquiryForm, setOpenInquiryForm }) {

    const [attachmentFile, setAttachmentFile] = useState(null);
    const initialValues = {
        child: "",
        category: "",
        message: "",
        attachment: null,
    };


    // Handle submit function
    const handleSubmit = (values) => {
        console.log("Form values:", values);
    };
    return (
        <div>

            <div>
                {openInquiryForm &&
                    <div className="fixed inset-0 z-50 flex items-center justify-center">
                        <div
                            className="absolute inset-0 bg-black bg-opacity-40"
                            onClick={() => setOpenInquiryForm(false)}
                        ></div>
                        <div className="relative bg-white rounded-xl shadow-lg w-full max-w-2xl p-6">
                            {/* Header */}
                            <div className="flex justify-between items-center border-b pb-3 mb-4">
                                <h2 className="text-lg text-[#283C50] font-semibold">
                                    Submit an Inquiry
                                </h2>
                                <button
                                    onClick={() => setOpenInquiryForm(false)}
                                    className="text-gray-400 hover:text-gray-600 text-xl"
                                >
                                    ✕
                                </button>
                            </div>

                            {/* Formik Form */}
                            <Formik
                                initialValues={initialValues}
                                onSubmit={handleSubmit}
                            >
                                {({ values, setFieldValue }) => (
                                    <Form className="max-h-[750px] overflow-y-auto pr-2 scrollbar-hide">

                                        {/* Subject */}
                                        <label className="text-md text-[#717576] font-normal">Select Child</label>
                                        <div className="relative">
                                            <Field
                                                as="select"
                                                name="child"
                                                className="w-full border py-2 px-4 text-md my-[9px] h-[60px] rounded-[10px] appearance-none pr-10 focus:outline-none focus-visible:outline-none"
                                            >
                                                <option value="">Choose a Child</option>
                                            </Field>

                                            {/* Custom dropdown arrow */}
                                            <svg
                                                width="20"
                                                height="11"
                                                viewBox="0 0 20 11"
                                                fill="none"
                                                xmlns="http://www.w3.org/2000/svg"
                                                className="absolute right-3 top-1/2 transform -translate-y-1/2 pointer-events-none"
                                            >
                                                <path d="M10 11L0 0L20 0L10 11Z" fill="black" />
                                            </svg>
                                        </div>


                                        <label className="text-md text-[#717576] font-normal">Select Inquiry Category</label>
                                        <div className="relative">
                                            <Field
                                                as="select"
                                                name="category"
                                                className="w-full border py-2 px-4 text-md my-[9px] h-[60px] rounded-[10px] appearance-none pr-10 focus:outline-none focus-visible:outline-none"
                                            >
                                                <option value="">Choose a Category</option>
                                            </Field>

                                            {/* Custom dropdown arrow */}
                                            <svg
                                                width="20"
                                                height="11"
                                                viewBox="0 0 20 11"
                                                fill="none"
                                                xmlns="http://www.w3.org/2000/svg"
                                                className="absolute right-3 top-1/2 transform -translate-y-1/2 pointer-events-none"
                                            >
                                                <path d="M10 11L0 0L20 0L10 11Z" fill="black" />
                                            </svg>
                                        </div>

                                        <div>
                                            <label className="text-md text-[#717576] font-normal">
                                                Message (Optional)
                                            </label>
                                            <Field
                                                as="textarea"
                                                name="message"
                                                placeholder="Please Describe your question or concern in detail. "
                                                className="w-full border p-2 text-md mt-[9px] bg-[#7175760F] rounded-[10px]"
                                                rows={4}
                                            />
                                        </div>
                                        <div>
                                            <label className="text-md text-[#717576] font-normal block mb-2">
                                                Attachment
                                            </label>
                                            <input
                                                id="attachment"
                                                name="attachment"
                                                type="file"
                                                className="hidden"
                                                onChange={(e) => {
                                                    const file = e.target.files[0];
                                                    setFieldValue("attachment", file);
                                                    setAttachmentFile(file);
                                                }}
                                            />
                                            <label
                                                htmlFor="attachment"
                                                className="w-full border rounded-[10px] bg-[#F7F7F7] h-[60px] flex items-center px-4 cursor-pointer hover:bg-gray-100 transition"
                                            >
                                                {attachmentFile ? (
                                                    <span className="text-gray-700 text-sm truncate">
                                                        {attachmentFile.name}
                                                    </span>
                                                ) : (
                                                    <span className="text-gray-500 text-sm">
                                                        Add your attachment here
                                                    </span>
                                                )}

                                                {/* Icon always on the far right */}
                                                <span className="ml-auto flex items-center">
                                                    <svg
                                                        width="24"
                                                        height="24"
                                                        viewBox="0 0 24 24"
                                                        fill="none"
                                                        xmlns="http://www.w3.org/2000/svg"
                                                    >
                                                        <path
                                                            d="M19.4632 5.57604C18.7752 4.82604 17.5342 4.78004 16.7072 5.60704L8.60718 13.707C8.39718 13.917 8.39718 14.183 8.60718 14.393C8.81718 14.603 9.08318 14.603 9.29318 14.393L15.9932 7.69304C16.1818 7.51089 16.4344 7.41009 16.6966 7.41237C16.9588 7.41465 17.2096 7.51982 17.395 7.70523C17.5804 7.89063 17.6856 8.14145 17.6879 8.40364C17.6901 8.66584 17.5893 8.91844 17.4072 9.10704L10.7072 15.807C10.4788 16.042 10.2057 16.2288 9.90391 16.3563C9.60212 16.4839 9.27782 16.5496 8.95018 16.5496C8.62255 16.5496 8.29824 16.4839 7.99645 16.3563C7.69466 16.2288 7.42152 16.042 7.19318 15.807C6.95822 15.5787 6.77145 15.3056 6.64391 15.0038C6.51637 14.702 6.45065 14.3777 6.45065 14.05C6.45065 13.7224 6.51637 13.3981 6.64391 13.0963C6.77145 12.7945 6.95822 12.5214 7.19318 12.293L15.2932 4.19304C16.8602 2.62504 19.4082 2.57404 20.9232 4.20804C22.4752 5.77704 22.5202 8.31204 20.8932 9.82104L11.4072 19.307C9.21718 21.497 5.78318 21.497 3.59318 19.307C1.40318 17.117 1.40318 13.683 3.59318 11.493L11.6932 3.39304C11.8818 3.21089 12.1344 3.11009 12.3966 3.11237C12.6588 3.11465 12.9096 3.21982 13.095 3.40523C13.2804 3.59063 13.3856 3.84145 13.3879 4.10364C13.3901 4.36584 13.2893 4.61844 13.1072 4.80704L5.00718 12.907C3.59718 14.317 3.59718 16.483 5.00718 17.893C6.41718 19.303 8.58318 19.303 9.99318 17.893L19.4932 8.39304L19.5242 8.36304C20.2742 7.67604 20.3202 6.43404 19.4932 5.60704L19.4632 5.57604Z"
                                                            fill="#496EB4"
                                                        />
                                                    </svg>
                                                </span>
                                            </label>

                                        </div>

                                        {/* Footer */}
                                        <div className="flex justify-between gap-3 pt-4">
                                            <button
                                                type="button"
                                                onClick={() => { setOpenInquiryForm(false); setAttachmentFile(null) }}
                                                className="px-4 py-4 w-full rounded-[10px] border border-brandBlue text-brandBlue bg-transparent hover:bg-brandBlue hover:text-white transition"
                                            >
                                                Cancel
                                            </button>

                                            <button
                                                type="submit"
                                                className="px-4 py-4 w-full rounded-[10px] bg-brandBlue text-white hover:bg-primary-700 transition"
                                            >
                                                Submit Request
                                            </button>
                                        </div>
                                    </Form>
                                )}
                            </Formik>
                        </div>

                    </div>
                }
            </div>
        </div>
    )
}
